import { useMutation, useQueryClient } from "react-query";

import client from "../../Client";

export const useStartContentWorkflowMutation = () => {
    return useMutation((params: { product_name: string; product_id: string; brave_mode: boolean }) =>
        client.post(`/v1/wfo/start-content-workflow`, params).then((res) => res.data)
    );
};

export const useResumeContentWorkflowMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(
        ({ workflowId, validation_data }: { workflowId: string; validation_data: any }) =>
            client.post(`/v1/wfo/resume-content-workflow/${workflowId}`, validation_data).then((res) => res.data),
        {
            onSuccess: (_, { workflowId }) => {
                queryClient.invalidateQueries(["wfo-current-step", workflowId]);
                queryClient.invalidateQueries(["wfo-validated-data", workflowId]);
            },
        }
    );
};
